<template>
    <div>
		<b-button variant="primary" :disabled="loading" @click="fetchOrders">
			<span :class="{ fa: true, 'fa-download': !loading, 'fa-sync': loading, 'fa-spin': loading }"></span>
			<span v-if="loading">Henter ordrer {{fetchDone}} / {{fetchDays}}</span>
			<span v-else>Hent ordrer</span>
		</b-button>

		<b-dropdown right split @click="printOrderList" variant="dark">
			<template v-slot:button-content>
				<span class="fa fa-print"></span> Print plukliste
			</template>
			<b-dropdown-item :disabled="!entities || entities.length == 0" @click="printSelected(entities)">Print valgte</b-dropdown-item>
		</b-dropdown>
		
		<b-button variant="warning" @click="startScanning"><span class="fa fa-barcode"></span> Start scanning</b-button>
	</div>
</template>

<script>
import printOrders from "../modals/printOrders.vue";
import orderScanning from "../modals/orderScanning.vue";

export default {
	data: () => ({
		loading: false,
		fetchDone: 0,
		fetchDays: 0
	}),
	props: ["entity", "entities"],
	components: {},
	computed: {},
	methods: {
		// Henter ordrerne en dag ad gangen. Serveren tager én dag pr. kald, så vi bliver ved
		// med at poste med stigende day indtil svaret melder at der ikke er flere dage.
		async fetchOrders() {
			this.loading = true;
			this.fetchDone = 0;
			this.fetchDays = 0;

			var day = 0;
			var orders = 0;
			var errors = [];

			try {
				while (true) {
					var x = await this.$http.post("/api/module/smartweborders/fetch-day?day=" + day);

					this.fetchDays = x.data.days;
					orders += x.data.orders;
					errors = errors.concat(x.data.errors || []);

					day += 1;
					this.fetchDone = Math.min(day, x.data.days);

					if (x.data.done) {
						break;
					}
				}

				var message = orders + " ordrer blev hentet.";
				if (errors.length > 0) {
					message += "\n\n" + errors.length + " dage fejlede:\n" + errors.join("\n");
				}

				alert(message);
			} catch (e) {
				alert("Hentningen blev afbrudt: " + e);
			}

			this.loading = false;
		},
		printOrderList() {
			this.$dialog.open(printOrders, {}, { title: "Print plukliste", okTitle: "Print" })
		},
		printSelected(selected) {
			var ids = selected.map(x => x.Id);
			this.$http({
				url: '/api/module/smartweborders/printselected',
				data: ids,
				method: 'POST',
				responseType: 'blob', // important
			}).then((response) => {
				this.$fileDownload(response.data, 'plukliste.pdf');

				this.$emit("ok");
			});
		},
		startScanning() {
			this.$dialog.open(orderScanning, {}, { title: "Scan ordre", okTitle: "Luk", okOnly: true })
		}
	},
	created() {},
	mounted() {}
};
</script>